/* eslint-disable camelcase */
import { Component, Vue } from 'vue-property-decorator'
import { RequestOperation } from '@/api/operations/models/request-operation'
import { CaseOperation } from '@/api/operations/models/case-operation'
import { IncidentOperation } from '@/api/operations/models/incident-operation'
import { REQUEST_STATES } from '@/api/resources/entityState/request-state'
import { Nullable } from '@/shared/types/app.types'

@Component
export class RequestOperationGuardMixin extends Vue {
    /// VALIDATIONS ///

    $_isRequestDraft(request: any): boolean {
        return REQUEST_STATES.DRAFT.code === request?.status.code
    }

    $_isRequestCompleted(request: any): boolean {
        return REQUEST_STATES.COMPLETED.code === request?.status.code
    }

    /// GUARD OPERATIONS ///

    $_canCreateRequest(laboratoryId?: Nullable<number>): boolean {
        if (laboratoryId) {
            return this.$_hasLabOperation(laboratoryId, RequestOperation.CREATE)
        }
        return this.$_hasOperationInCurrentLaboratory(RequestOperation.CREATE)
    }
    $_canProcessRequest(request: any): boolean {
        const isStateOk = [REQUEST_STATES.REQUESTED.code, REQUEST_STATES.LOCKED.code].includes(request?.status.code)
        return isStateOk &&
            this.$_hasOperationInCurrentLaboratory(RequestOperation.PROCESS) &&
            this.$_hasOperationInCurrentLaboratory(CaseOperation.CREATE)
    }
    $_canCancelRequest(laboratoryId?: Nullable<number>): boolean {
        if (laboratoryId) {
            return this.$_hasLabOperation(laboratoryId, RequestOperation.PETITIONER_CANCEL) ||
                this.$_hasLabOperation(laboratoryId, RequestOperation.PERSONNEL_CANCEL)
        }
        return this.$_hasOperationInCurrentLaboratory(RequestOperation.PERSONNEL_CANCEL) ||
            this.$_hasOperationInCurrentLaboratory(RequestOperation.PETITIONER_CANCEL)
    }
    $_canPrintRequestReport(laboratoryId?: Nullable<number>): boolean {
        if (laboratoryId) {
            return this.$_hasLabOperation(laboratoryId, RequestOperation.PRINT) ||
                this.$_hasLabOperation(laboratoryId, RequestOperation.PRINT_REQUEST_AND_LABELS)
        }
        return this.$_hasOperationInCurrentLaboratory(RequestOperation.PRINT) ||
            this.$_hasOperationInCurrentLaboratory(RequestOperation.PRINT_REQUEST_AND_LABELS)
    }
    $_canGoToCaseView(requestStatusCode: Nullable<string>): boolean {
        return REQUEST_STATES.REGISTERED.code === requestStatusCode || REQUEST_STATES.COMPLETED.code === requestStatusCode
    }
    $_canReturnRequest(requestStatusCode: Nullable<string>): boolean {
        const isStateOk = REQUEST_STATES.LOCKED.code === requestStatusCode
        return isStateOk &&
            this.$_hasOperationInCurrentLaboratory(RequestOperation.RETURN)
    }
    $_canPrintReturnForm(requestStatusCode: Nullable<string>): boolean {
        const isStateOk = REQUEST_STATES.RETURNED.code === requestStatusCode
        return isStateOk &&
            this.$_hasOperationInCurrentLaboratory(IncidentOperation.PRINT)
    }
    $_canReturnRequestAndPrintReturnForm(requestStatusCode: Nullable<string>): boolean {
        const isStateOk = REQUEST_STATES.LOCKED.code === requestStatusCode
        return isStateOk &&
            this.$_hasOperationInCurrentLaboratory(RequestOperation.RETURN) &&
            this.$_hasOperationInCurrentLaboratory(IncidentOperation.PRINT)
    }

    /// CAN BE ///

    $_canBeRequestCanceled(request: any): boolean {
        return [REQUEST_STATES.REQUESTED.code, REQUEST_STATES.LOCKED.code].includes(request?.status.code)
    }
    $_canBeRequestCanceledClinicalModule(request: any): boolean {
        return [REQUEST_STATES.REQUESTED.code].includes(request?.status.code)
    }
    $_canBeRequestReportPrinted(request: any): boolean {
        return !this.$_isRequestDraft(request)
    }
    $_canBeIncidentCreatedToRequest(request: any): boolean {
        return [REQUEST_STATES.REQUESTED.code, REQUEST_STATES.REGISTERED.code, REQUEST_STATES.LOCKED.code].includes(request?.status.code)
    }
}
